export default "__VITE_ASSET__CQzbenHU__"